module.exports = __webpack_public_path__ + "static/media/22.3ac56b90.jpg";